import { createSlice } from '@reduxjs/toolkit';
import { ConfigurationState } from '../../../types/configuration';

const INITIAL_STATE: ConfigurationState = {
  settings: undefined,
  configLoadFailed: false,
};

const configSlice = createSlice({
  name: 'config',
  initialState: INITIAL_STATE,
  reducers: {
    storeConfig: (state, action) => {
      const { config } = action.payload;
      state.settings = config;
    },
    setConfigLoadFailed: (state, action) => {
      state.configLoadFailed = action.payload;
    },
  },
});

export const { storeConfig, setConfigLoadFailed } = configSlice.actions;

export default configSlice.reducer;
